export const gitCommit = 'eefe61b1'
